import { CellType, ChartType, DataType, FilterType, SerieType } from '@colven/common-domain-lib/lib'
import i18n from "@/i18n"
import { dateSortFunction } from '@/tools/functions'
import { compareNumberSplitString } from '../tools/functions'


export const MAP_POINT_TEMPLATE = {
    id: null,
    lat: null,
    lng: null,
    value: "TRUCK",
    filters: [],
    marker: {
        title: "",
        type: "img",
        ref: "truck-icon.svg",
        size: 40,
        tooltipDirection: "right",
        tooltipPermanent: false,
        tooltipBorderColor: "rgb(0,176,240)",
        businessData: {
            direction: "northeast",
            stopped: false
        },
    },
}

export const MAP_TEMPLATE = {
    id: 1,
    name: i18n.t('dischargeDetail.map.name'),
    groups: [{
        id: 'dischargeDetailMapGroup',
        name: i18n.t('dischargeDetail.map.groupName'),
        title: i18n.t('dischargeDetail.map.groupName'),
        referenceByInterval: true,
        series: [{
            type: SerieType.MARKERS,
            points: []
        }],
        references: [{
            name: '10-discharge',
            color: '#a6d96a',
            isInterval: true,
            intervalStart: 0,
            intervalEnd: 20,
        },
        {
            name: '20-discharge',
            color: '#ffffbf',
            isInterval: true,
            intervalStart: 20,
            intervalEnd: 40,
        },
        {
            name: '30-discharge',
            color: '#fdae61',
            isInterval: true,
            intervalStart: 40,
            intervalEnd: 60,
        },
        {
            name: '40-discharge',
            color: '#d7191c',
            isInterval: true,
            intervalStart: 60,
            intervalEnd: 80,
        },
        {
            name: '50-discharge',
            color: '#543005',
            isInterval: true,
            intervalStart: 80
        }
        ],
        exclusive: true,
        displayOnStart: true
    }],
    filters: [],
    info: {}
}

export const TABLE_HEADERS_DISCHARGE = [{
    text: i18n.t('table.headers.discharge.nameThing'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'nameThing',
    width: 220
},
{
    text: i18n.t('table.headers.discharge.serviceType'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'serviceType',
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.eventTimestamp'),
    align: 'left',
    filterType: FilterType.textField,
    sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') },
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'positionTimestamp',
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.communicationTimestamp'),
    align: 'left',
    filterType: FilterType.textField,
    sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') },
    selected: true,
    sortable: true,
    type: DataType.string,
    value: i18n.t('communicationTimestamp'),
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.amountDischarged'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'dischargeAmount',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.odometer'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'odometer',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.engineState'),
    align: 'left',
    filterType: FilterType.multiSelect,
    options: [
        i18n.t('table.data.engineState.OFF'),
        i18n.t('table.data.engineState.ON')
    ],
    selected: true,
    sortable: true,
    type: DataType.boolean,
    cellType: CellType.textBackgroundColor,
    cellConfig: {
        round: true,
        color: 'engineStateColor',
    },
    value: 'engineState',
    width: 170,
},
{
    text: i18n.t('table.headers.dischargeDetail.speed'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'speed',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.globalVolume'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'globalVolume',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
/*{
    text: i18n.t('table.headers.dischargeDetail.dischargedTank'),
    align: 'left',
    filterType: FilterType.multiSelect,
    options: [
        i18n.t('table.data.tank.TANK_1'),
        i18n.t('table.data.tank.TANK_2'),
        i18n.t('table.data.tank.TANK_3'),
        i18n.t('table.data.tank.TANK_4')
    ],
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'dischargedTank',
    width: 220
},*/
{
    text: i18n.t('table.headers.dischargeDetail.dischargeAddress'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'geoReferenceEnd',
    width: 220
},
]

export const TABLE_HEADERS_IDLING = [{
    text: i18n.t('table.headers.discharge.nameThing'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'nameThing',
    width: 220
},
{
    text: i18n.t('table.headers.discharge.serviceType'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'serviceType',
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.eventTimestamp'),
    align: 'left',
    filterType: FilterType.textField,
    sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') },
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'positionTimestamp',
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.communicationTimestamp'),
    align: 'left',
    filterType: FilterType.textField,
    sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') },
    selected: true,
    sortable: true,
    type: DataType.string,
    value: i18n.t('communicationTimestamp'),
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.amountConsumed'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'dischargeAmount',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.dischargeTime'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'idlingTime',
    width: 220
},
{
    text: i18n.t('table.headers.dischargeDetail.odometer'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'odometer',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.engineState'),
    align: 'left',
    filterType: FilterType.multiSelect,
    options: [
        i18n.t('table.data.engineState.OFF'),
        i18n.t('table.data.engineState.ON')
    ],
    selected: true,
    sortable: true,
    type: DataType.boolean,
    cellType: CellType.textBackgroundColor,
    cellConfig: {
        round: true,
        color: 'engineStateColor',
    },
    value: 'engineState',
    width: 170,
},
{
    text: i18n.t('table.headers.dischargeDetail.globalVolume'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.number,
    value: 'globalVolume',
    width: 220,
    sort: (a, b) => { return compareNumberSplitString(a, b, " ") }
},
{
    text: i18n.t('table.headers.dischargeDetail.idlingAddress'),
    align: 'left',
    filterType: FilterType.textField,
    selected: true,
    sortable: true,
    type: DataType.string,
    value: 'geoReferenceEnd',
    width: 220
},
]

export const TABLE_DATA_TEMPLATE = {
    numericId: null,
    nameThing: null,
    serviceType: null,
    positionTimestamp: null,
    communicationTimestamp: null,
    positionTimestampColor: null,
    communicationTimestampColor: null,
    dischargeAmount: null,
    odometer: null,
    engineState: null,
    speed: null,
    globalVolume: null,
    dischargedTank: null,
    geoReference: null,
    lat: null,
    lng: null
}

export const CHART_TEMPLATE = {
    id: 'dischargeDetailChart',
    name: i18n.t('dischargeDetail.chart.name'),
    type: ChartType.BAR,
    data: {
        labels: [],
        datasets: []
    },
    options: {
        // TODO: analizar si hay que agregar el rango de tiempo como los gráficos del portal
        title: {
            display: false,
            text: ''
        },
        legend: false,
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    display: false
                },
                stacked: false,
                ticks: {
                    beginAtZero: true
                },
                scaleLabel: {
                    display: true,
                    labelString: i18n.t('dischargeDetail.chart.xLabel')
                },
                /*
                type: 'time',
                time: {
                    parser: 'X',
                    unit: 'minute',
                    tooltipFormat: 'DD-MM-YY HH:mm:ss',
                    displayFormats: {
                        minute: 'DD-MM-YY HH:mm:ss',
                    },
                },
                */
            }],
            yAxes: [{
                display: true,
                gridLines: {
                    display: true
                },
                stacked: false,
                ticks: {
                    beginAtZero: true
                },
                scaleLabel: {
                    display: true,
                    labelString: i18n.t('dischargeDetail.chart.yLabel')
                }
            }]
        },
        tooltips: {
            mode: 'x',
            intersect: false,
            callbacks: {
                label: function (tooltipItem, data) {
                    return data.datasets[tooltipItem.datasetIndex].formattedTooltipData.label[tooltipItem.index];
                }
            }
        },
        plugins: {
            zoom: {
                pan: {
                    enabled: true,
                    mode: 'xy'
                },
                zoom: {
                    enabled: true,
                    mode: 'xy'
                }
            }
        },
        animation: {
            duration: 0
        },
        hover: {
            animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        responsive: true,
        maintainAspectRatio: false
    },
    showDatalabels: false
}

export const CHART_DATASET_TEMPLATE = {
    type: undefined,
    label: i18n.t('dischargeDetail.chart.yLabel'),
    dataProperty: undefined,
    originalData: [],
    data: [],
    formattedTooltipData: {
        label: []
    },
    formattedLabelData: [],
    backgroundColor: [],
    borderWidth: 1,
    fill: true,
    yAxisID: undefined,
    lineTension: 0
}